/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getProductLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/product_labels`);
  }

  updateProductLabels(conversationID, productLabels) {
    return axios.post(`${this.url}/${conversationID}/product_labels`, {
      product_labels: productLabels,
    });
  }

  getTopicLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/topic_labels`);
  }

  updateTopicLabels(conversationID, topicLabels) {
    return axios.post(`${this.url}/${conversationID}/topic_labels`, {
      topic_labels: topicLabels,
    });
  }

  getConcurrentLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/concurrent_labels`);
  }

  updateConcurrentLabels(conversationID, concurrentLabels) {
    return axios.post(`${this.url}/${conversationID}/concurrent_labels`, {
      concurrent_labels: concurrentLabels,
    });
  }
}

export default new ConversationApi();
